import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer>
      <div className='row'>
        <h4 className='text-center'><a href='mailto:keytrainingorg@gmail.com' target='_blank'>&copy; 2017 KEY Training, Inc.</a></h4>
      </div>
    </footer>
  )
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js